import { View, Text } from '@react-pdf/renderer';
import { shared } from '../styles';
import { ClinicalInstructionsDocument } from '../ClinicalInstructionsDocument';
import type { ClinicalDocVariant } from '../ClinicalInstructionsDocument';
import type { SDIFormData, SectionToggles } from '../../clinical/types';

interface SdiDocumentProps {
    data: SDIFormData;
    hasOrthopulse: boolean;
    toggles: SectionToggles;
}

const variant: ClinicalDocVariant = {
    title: 'Start Day Information:',
    notesKey: 'sdi-notes',
    alignerScheduleTitle: 'Suggested aligner wear schedule:',
    alignerScheduleNote: (
        <View style={shared.section}>
            <Text style={shared.warningText}>
                ODO will monitor and notify you of any suggested appointment changes.
            </Text>
        </View>
    ),
    helpLinkAdditionalText: 'For additional instructions (Bonding attachments etc), visit here:'
};

function SdiDocument({ data, hasOrthopulse, toggles }: SdiDocumentProps) {
    return (
        <ClinicalInstructionsDocument
            data={{ ...data, nextAppointmentValue: data.nextAppointmentAligner }}
            hasOrthopulse={hasOrthopulse}
            toggles={toggles}
            variant={variant}
        />
    );
}

export { SdiDocument };
